// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-me-wrapper {
  padding: 25px;
  width: 95%;
  align-self: center;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
}

.enquiries-wrapper {
  background: white;
  display: flex;
  flex-direction: column;
  border: 1px solid #939393;
  border-radius: 5px;
  padding: 15px;
  max-width: fit-content;
  width: 100%;
}

.additional-contact-wrapper {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.enquiries-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.enquiries-form > button {
  width: 100%;
}

.enquiries-content {
  display: flex;
  flex-direction: column;
  max-width: 500px;
  margin-bottom: 20px;
  padding: 10px;
  align-self: center;
}

.message {
  width: 100%;
  height: 100%;
  max-height: 75px;
  resize: vertical;
}

.name-wrapper {
  display: flex;
}

.first,
.last,
.subject {
  width: 100%;
}

.email-wrapper,
.message-wrapper,
.email-wrapper > .email {
  width: 100%;
}

.email {
  width: -webkit-fill-available;
}

.margin-5 {
  margin: 5px;
}

@media (max-width: 750px) {
  .contact-me-wrapper {
    flex-direction: column;
    align-items: center;
  }
  .additional-contact-wrapper {
    margin-bottom: 50px;
  }
}

@media (max-width: 500px) {
  .additional-contact-wrapper {
    margin: 0 0 20px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/contact-me/contact-me.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".contact-me-wrapper {\n  padding: 25px;\n  width: 95%;\n  align-self: center;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-around;\n}\n\n.enquiries-wrapper {\n  background: white;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #939393;\n  border-radius: 5px;\n  padding: 15px;\n  max-width: fit-content;\n  width: 100%;\n}\n\n.additional-contact-wrapper {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.enquiries-form {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.enquiries-form > button {\n  width: 100%;\n}\n\n.enquiries-content {\n  display: flex;\n  flex-direction: column;\n  max-width: 500px;\n  margin-bottom: 20px;\n  padding: 10px;\n  align-self: center;\n}\n\n.message {\n  width: 100%;\n  height: 100%;\n  max-height: 75px;\n  resize: vertical;\n}\n\n.name-wrapper {\n  display: flex;\n}\n\n.first,\n.last,\n.subject {\n  width: 100%;\n}\n\n.email-wrapper,\n.message-wrapper,\n.email-wrapper > .email {\n  width: 100%;\n}\n\n.email {\n  width: -webkit-fill-available;\n}\n\n.margin-5 {\n  margin: 5px;\n}\n\n@media (max-width: 750px) {\n  .contact-me-wrapper {\n    flex-direction: column;\n    align-items: center;\n  }\n  .additional-contact-wrapper {\n    margin-bottom: 50px;\n  }\n}\n\n@media (max-width: 500px) {\n  .additional-contact-wrapper {\n    margin: 0 0 20px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
